import { useQuery } from "@tanstack/react-query";
import { api, type StaffMe } from "./api.ts";
import { useSession } from "./auth.ts";

// Drives the staff-portal entry point: returns isStaff/role for the current
// user. Cached for the session — staff role rarely changes mid-session, and
// the global API middleware re-checks on every request anyway, so the SPA
// can keep its cached copy.
export function useStaff() {
  const { data: session, isPending: sessionPending } = useSession();
  const enabled = !!session?.user && !sessionPending;
  const q = useQuery<StaffMe>({
    queryKey: ["staff", "me"],
    queryFn: api.staffMe,
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
  });
  return {
    isPending:        sessionPending || (enabled && q.isPending),
    isStaff:          q.data?.isStaff ?? false,
    role:             q.data?.role ?? null,
    hasOrgMembership: q.data?.hasOrgMembership ?? false,
  };
}
